import { getStoredSessionToken } from './sessionToken'

/**
 * Adds `Authorization: Bearer <Parse session token>` to the headers of a server call.
 * With no stored session the header is left out, so the server answers 401 and the caller keeps
 * its usual error handling.
 */
export function withBearerAuth(headers: Record<string, string> = {}): Record<string, string> {
  const token = getStoredSessionToken()
  return token ? { ...headers, Authorization: `Bearer ${token}` } : { ...headers }
}
